var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94297 16.4274C4.55039 16.4274 3.14942 15.8989 2.08401 14.8335C-0.0384194 12.7027 -0.0384194 9.24638 2.08401 7.12396C2.32729 6.88067 2.72996 6.88067 2.97325 7.12396C3.21653 7.36724 3.21653 7.76991 2.97325 8.0132C1.33738 9.64906 1.33738 12.3084 2.97325 13.9442C4.60911 15.5801 7.26844 15.5801 8.9043 13.9442C9.69287 13.1557 10.1291 12.0987 10.1291 10.9745C10.1291 9.85878 9.69287 8.80176 8.9043 8.00481C8.66102 7.76152 8.66102 7.35885 8.9043 7.11557C9.14758 6.87228 9.55026 6.87228 9.79354 7.11557C10.8254 8.14742 11.3875 9.51483 11.3875 10.9745C11.3875 12.4342 10.817 13.8016 9.79354 14.8335C8.73652 15.8989 7.34394 16.4274 5.94297 16.4274Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3992 10.2702C14.2399 10.2702 14.0805 10.2115 13.9546 10.0856C13.7113 9.84234 13.7113 9.43966 13.9546 9.19638C15.6744 7.47663 15.6744 4.68308 13.9546 2.97171C12.2349 1.25196 9.44132 1.25196 7.72996 2.97171C6.89944 3.80223 6.43804 4.90958 6.43804 6.08405C6.43804 7.25851 6.89944 8.36587 7.72996 9.19638C7.97324 9.43966 7.97324 9.84234 7.72996 10.0856C7.48667 10.3289 7.084 10.3289 6.84072 10.0856C5.77531 9.02021 5.17969 7.59407 5.17969 6.08405C5.17969 4.57402 5.76692 3.14788 6.84072 2.08247C9.04704 -0.123845 12.6375 -0.123845 14.8523 2.08247C17.0586 4.28879 17.0586 7.88769 14.8523 10.094C14.7264 10.2115 14.5586 10.2702 14.3992 10.2702Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.ad8ce642b0a5d215713bfb48bd252b59.svg";
export { ForwardRef as ReactComponent };